import { Base } from "../../framework/base";
import { stateGray, stateGreen, stateOrange } from "../consts";
import { EnumHelper, RecordEducationScopeUnit, UserFurtherEducationState } from "../enums";
import { Translations } from "../translations";

export interface IRecordListItemUserFurtherEducation {
    id: string;
    furtherEducationId: string;
    furtherEducationCode: string;
    startDate: number;
    endDate: number;
    validityEndDate: number;
    archived: boolean;
    scope: number;
    scopeUnit: RecordEducationScopeUnit;
    scopeUnitStr: string;
    state: UserFurtherEducationState;
    hasAttachments: boolean;
    modifyDate: number;

    getIsArchived(): boolean;
}

export class RecordListItemUserFurtherEducation implements IRecordListItemUserFurtherEducation {
    id: string;
    furtherEducationId: string;
    furtherEducationCode: string;
    startDate: number;
    endDate: number;
    validityEndDate: number;
    archived: boolean;
    scope: number;
    scopeUnit: RecordEducationScopeUnit;
    scopeUnitStr: string;
    state: UserFurtherEducationState;
    hasAttachments: boolean;
    modifyDate: number;

    constructor();
    constructor(obj: IRecordListItemUserFurtherEducation);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.furtherEducationId = obj && obj.furtherEducationId || "";
        this.furtherEducationCode = obj && obj.furtherEducationCode || "";
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj && obj.endDate || null;
        this.validityEndDate = obj && obj.validityEndDate || null;
        this.archived = obj && obj.archived || false;
        this.scope = obj && obj.scope || 0;
        this.scopeUnit = obj && obj.scopeUnit || RecordEducationScopeUnit.Hour;
        this.scopeUnitStr = this.scope === 1
            ? EnumHelper.RecordEducationScopeUnitToStr(this.scopeUnit)
            : EnumHelper.RecordEducationScopeUnitToStrPlural(this.scopeUnit);
        this.state = obj && obj.state || UserFurtherEducationState.Valid;
        this.hasAttachments = obj && obj.hasAttachments || false;
        this.modifyDate = obj && obj.modifyDate || 0;
    }

    getIsArchived(): boolean {
        return this.archived;
    }
    
    static getRecordUserFurtherEducationState(state: UserFurtherEducationState): string {
        return state === UserFurtherEducationState.Valid
            ? Translations.Valid
            : (state === UserFurtherEducationState.Expired
                ? Translations.Expired
                : Translations.Archived);
    }

    static getRecordUserFurtherEducationStateColor(state: UserFurtherEducationState): string {
        return state === UserFurtherEducationState.Valid
            ? stateGreen
            : (state === UserFurtherEducationState.Expired
                ? stateOrange
                : stateGray);
    }

    static sortRecordListItemUserFurtherEducations(items: IRecordListItemUserFurtherEducation[], column: string, asc: boolean): IRecordListItemUserFurtherEducation[] {
        if (!items && items.length < 2) return items;
        if (column === "validityDuration") {
            return items.sort((a: IRecordListItemUserFurtherEducation, b: IRecordListItemUserFurtherEducation) => {
                if (!a || !b) return 0;
                if (!a.validityEndDate && !b.validityEndDate) {
                    return ((asc ? 1 : -1) * -1 * Base.numCompare(a.startDate, b.startDate));
                }
                if (!a.validityEndDate) {
                    return asc ? 1 : -1;
                }
                if (!b.validityEndDate) {
                    return asc ? -1 : 1;
                }
                return (asc ? 1 : -1) * Base.numCompare(a.validityEndDate, b.validityEndDate);
            });
        } else if (column === "startDate") {
            return items.sort((a: IRecordListItemUserFurtherEducation, b: IRecordListItemUserFurtherEducation) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.startDate, b.startDate)); });
        } else if (column === "validityEndDate") {
            return items.sort((a: IRecordListItemUserFurtherEducation, b: IRecordListItemUserFurtherEducation) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.validityEndDate, b.validityEndDate)); });
        } else if (column === "state") {
            return items.sort((a: IRecordListItemUserFurtherEducation, b: IRecordListItemUserFurtherEducation) => {
                if (!a || !b) return 0;
                let result = (asc ? 1 : -1) * Base.numCompare(a.state, b.state);
                if (result !== 0) {
                    return result;
                }
                result = (asc ? 1 : -1) * Base.strCompare(a.furtherEducationCode, b.furtherEducationCode);
                if (result !== 0) {
                    return result;
                }
                return ((asc ? 1 : -1) * Base.numCompare(a.startDate, b.startDate));
            });
        } else {
            return items.sort((a: IRecordListItemUserFurtherEducation, b: IRecordListItemUserFurtherEducation) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.furtherEducationCode, b.furtherEducationCode)); });
        }
    }
}